import React, { useEffect, useState } from 'react';
import CompanySearchForm from '../components/ubo/CompanySearchForm';
import * as companySearchService from '../services/companySearch.service';
import CompanySearchList from 'src/components/ubo/CompanySearchList';
import { CompanyResults } from 'src/types/ICompany';
import { CompanySearchParams } from 'src/types';
import * as notify from 'src/services/notification.service';
import { handleUBOErrors } from 'src/services/errors.service';

const emptyResult: CompanyResults = {
  companies: [],
  transactionId: '',
  source: '',
  priorities: [],
  totalSize: 0,
};

const CompanyReportPage: React.FC = () => {
  let companySearchParamsDefaultValues = {
    companyName: '',
    registrationNo: '',
    countryISO: '',
    screening: 'on',
    stateCode: '',
  };

  const [pristine, setPristine] = useState<boolean>(true);
  const [showIsEmptyScreen, setShowIsEmptyScreen] = useState<boolean>(true);
  const [loadingSearch, setLoadingSearch] = useState<boolean>(false);

  const [searchParameters, setSearchParameters] = useState<CompanySearchParams>({
    ...companySearchParamsDefaultValues,
  });
  const [companySearchResults, setCompanySearchResults] = useState<CompanyResults>(emptyResult);

  const getCompanySearchResults = async (searchParameters: CompanySearchParams) => {
    setLoadingSearch(true);
    try {
      let results = await companySearchService.searchCompany(searchParameters);
      if (results?.data?.success && results?.data?.data?.companies?.length === 0) {
        notify.success('No companies match your search. Please try another search.');
        setShowIsEmptyScreen(true);
      } else if (results?.data?.success && results?.data?.data?.companies?.length) {
        setCompanySearchResults(results.data.data);
      } else {
        notify.error('Error getting search results.');
      }
    } catch (err: any) {
      if (
        err?.response?.data?.error?.errorMessages?.length &&
        err?.response?.data?.error?.errorMessages?.some(
          (errorMessage: any) => errorMessage.message === 'isEmpty',
        )
      ) {
        // We do not want to show an error in the case there are empty results for the company report search
        setShowIsEmptyScreen(true);
        return;
      }

      handleUBOErrors(err);
    } finally {
      setLoadingSearch(false);
    }
  };

  const resetResults = () => {
    setCompanySearchResults(emptyResult);
  };

  const searchParamsChanged = (params: CompanySearchParams) => {
    setShowIsEmptyScreen(false);
    setSearchParameters(params);
  };

  useEffect(() => {
    // console.log('Search Params Updated.');

    //Prevent empty call because on initial data set useEffect also being called.
    if (searchParameters.companyName || searchParameters.companyCode) {
      setPristine(false);
      getCompanySearchResults(searchParameters);
    }
  }, [searchParameters]);

  return (
    <div>
      <CompanySearchForm search={searchParamsChanged} resetResults={resetResults} />
      <div className="col-lg-12 mt-10 p-0">
        <div className="card-title">
          <h4>RESULTS</h4>
        </div>
      </div>
      {pristine && (
        <div className="test">
          <div className="d-flex align-items-center justify-content-center">
            <div className="card w-100">
              <div className="py-8 text-center mx-auto mw-20">
                <img
                  src={require('src/assets/images/placeholder-illustration.svg').default}
                  alt="Placeholder illustration"
                />
                <p className="mt-8 color-monoNormal">Enter company name to see screening results</p>
              </div>
            </div>
          </div>
        </div>
      )}
      {!pristine && !showIsEmptyScreen && !loadingSearch && (
        <CompanySearchList
          companySearchParams={searchParameters}
          companySearchResults={companySearchResults}
        />
      )}

      {!pristine && showIsEmptyScreen && (
        <div className="test">
          <div className="d-flex align-items-center justify-content-center">
            <div className="card w-100">
              <div className="py-8 text-center mx-auto mw-20">
                <img
                  src={require('src/assets/images/empty-search.svg').default}
                  alt="empty-search"
                />
                <p className="mt-8 color-monoNormal">
                  <div>No results found</div> <div>Please try another search</div>
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

      {loadingSearch && (
        <div className="test">
          <div className="d-flex align-items-center justify-content-center">
            <div className="card w-100">
              <div className="text-center mx-auto mw-20">
                <img src={require('src/assets/images/icons/company_detail_spinner_transparent.gif')} alt="" />
                <p className="color-monoNormal">Searching...</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CompanyReportPage;
